import {useSelector} from "react-redux";
import {NavLink} from "react-router-dom";
import {getPagesVisibility} from "../Privileges/PrivilegesSelectors";
import {createUseStyles} from "react-jss";
import useSidebar from "../../Shared/Sidebar/useSidebar";
import {Sidebar} from "../../Shared/Sidebar/Sidebar";

const {Pane} = require("evergreen-ui");
const React = require("react");

const useStyles = createUseStyles({
    settingsSidebarGroupNav: {
        fontFamily: '"SF UI Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        textDecoration: 'none',
        color: 'rgb(66, 90, 112)',
        padding: '.5em 1em .5em 1em',
        fontSize: '.9em',
        borderRadius: '.5em'
    },

    settingsSidebarGroupNavActive: {
        color: 'rgb(16, 112, 202)',
        backgroundColor: 'rgba(16, 112, 202, 0.09) !important'
    }
})

function ConstructorSidebar() {
    const {isPinned, isHide, onChangeHide, onChangePinned} = useSidebar();
    const classes = useStyles();
    const privileges = useSelector(state => state.login.privileges)

    const pagesVisibility = getPagesVisibility(privileges);

    return (
        <Sidebar
            isPinned={isPinned}
            isHide={isHide}
            onClickHide={onChangeHide}
            onClickPin={onChangePinned}
            title="Конструкторы"
            width={400}
            containerStyles={{
                display: 'grid',
                padding: '.5rem',
            }}
        >
            <Pane>
                {
                    pagesVisibility.CONSTRUCTORS ?
                        <>
                            <Pane marginBottom={17} marginTop={6}>
                                <NavLink
                                    to={"day-decade-month-values"}
                                    className={classes.settingsSidebarGroupNav}
                                    activeClassName={classes.settingsSidebarGroupNavActive}
                                >
                                    Суточные, декадные, месячные
                                    значения
                                </NavLink>
                            </Pane>

                            <Pane marginBottom={17}>
                                <NavLink
                                    to={"temporary-turn"}
                                    className={classes.settingsSidebarGroupNav}
                                    activeClassName={classes.settingsSidebarGroupNavActive}
                                >
                                    Временной ход
                                </NavLink>
                            </Pane>

                            <Pane marginBottom={17}>
                                <NavLink
                                    to={"rain-flood"}
                                    className={classes.settingsSidebarGroupNav}
                                    activeClassName={classes.settingsSidebarGroupNavActive}
                                >
                                    Дождевые паводки
                                </NavLink>
                            </Pane>

                            <Pane marginBottom={17}>
                                <NavLink
                                    to={"river-flood"}
                                    className={classes.settingsSidebarGroupNav}
                                    activeClassName={classes.settingsSidebarGroupNavActive}
                                >
                                    Половодье
                                </NavLink>
                            </Pane>

                          <Pane marginBottom={17}>
                            <NavLink
                                to={"evaporation"}
                                className={classes.settingsSidebarGroupNav}
                                activeClassName={classes.settingsSidebarGroupNavActive}
                            >
                              Наблюдение испарения
                            </NavLink>
                          </Pane>
                        </>
                    : <></>
                }
            </Pane>
        </Sidebar>
    );
}

export default function ConstructorSidebarWrapper() {
    return ConstructorSidebar()
}